module.exports = __webpack_public_path__ + "static/media/pic_a.a539acd7.png";